/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

const toMultipartFormData = (data = {}) => {
  if (data instanceof FormData) {
    return data;
  }

  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return;
    }

    formData.append(key, value);
  });

  return formData;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAllDriverTrips: (data = { type: 0 }) => {
    return axios.post(API_ENDPOINTS.GET_DRIVER_ALL_TRIPS, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json", "x-tenant-slug": "default" },
    });
  },
  verifyPickupOtp: (trip_id) => {
    return axios.post(API_ENDPOINTS.VERIFY_PICKUP_OTP, { trip_id }, {
      headers: { isAuthRequired: true, "Content-Type": "application/json", "x-tenant-slug": "default" },
    });
  },
  userPickedup: (trip_id) => {
    return axios.post(API_ENDPOINTS.USER_PICKEDUP, { trip_id }, {
      headers: { isAuthRequired: true, "Content-Type": "application/json", "x-tenant-slug": "default" },
    });
  },
  rejectTrip: (trip_id) => {
    return axios.post(API_ENDPOINTS.DRIVER_REJECT_TRIP, { request: trip_id }, {
      headers: { isAuthRequired: true, "Content-Type": "application/json", "x-tenant-slug": "default" },
    });
  },
  regretTrip: (trip_id) => {
    return axios.post(API_ENDPOINTS.DRIVER_REGRET_TRIP, { request: trip_id }, {
      headers: { isAuthRequired: true, "Content-Type": "application/json", "x-tenant-slug": "default" },
    });
  },
  acceptTrip: (trip_id) => {
    return axios.post(API_ENDPOINTS.DRIVER_ACCEPT_TRIP, { request: trip_id }, {
      headers: { isAuthRequired: true, "Content-Type": "application/json", "x-tenant-slug": "default" },
    });
  },
  getDriverList: (params) => {
    return axios.get(API_ENDPOINTS.GET_DRIVER_USER, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
      params,
    });
  },
  getDriverDetailsById: (id) => {
    let url = API_ENDPOINTS.DRIVER_ENDPOINT + "/" + id;
    return axios.get(url, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
    });
  },
  getDriverById: (id) => {
    let url = API_ENDPOINTS.GET_ONE_DRIVER_ENDPOINT + "/" + id;
    return axios.get(url, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
    });
  },
  requestOtp: (data) => {
    return axios.post(`${API_ENDPOINTS.DRIVER_ENDPOINT}/request-otp`, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json", "x-tenant-slug": "default" },
    });
  },
  requestEmailOtp: (data) => {
    return axios.post(`${API_ENDPOINTS.DRIVER_ENDPOINT_V2}/sent-email-otp`, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json", "x-tenant-slug": "default" },
    });
  },
  verifyEmailOtp: (data) => {
    return axios.post(`${API_ENDPOINTS.DRIVER_ENDPOINT_V2}/verify-email-otp`, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json", "x-tenant-slug": "default" },
    });
  },
  
  getDocumentsTypes: () => {
    let url = API_ENDPOINTS.DRIVER_DOCUMENTS_TYPE ;
    return axios.get(url, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
    });
  },
  getDocumentsTypesV2: (typeUser) => {
    let url = API_ENDPOINTS.DRIVER_DOCUMENTS_TYPE_V2;
    return axios.get(url, {
      headers: { "Content-Type": "application/json", "x-tenant-slug": "default" },
      params: { type_user: typeUser },
    });
  },
  getdriverEarningList: (params) => {
    return axios.get(API_ENDPOINTS.GET_ALL_DRIVER_EARNINGS_LIST, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
      params,
    });
  },
  getdriverEarning: (params) => {
    return axios.get(API_ENDPOINTS.GET_A_DRIVER_EARNINGS_LIST, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
      params,
    });
  },
  getdriverRewardsList: (params) => {
  return axios.get(API_ENDPOINTS.GET_ALL_DRIVER_REWARDS_LIST, {
    headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
    params,
  });
  },
  getdriverRewardlogs: (params) => {
    return axios.get(API_ENDPOINTS.GET_A_DRIVER_REWARDS_LIST, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
      params,
    });
  },
   getdriverscashoutrecords: (params) => {
    return axios.get(API_ENDPOINTS.GET_A_DRIVERS_CASHOUTRECORDS, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
      params,
    });
  },
updatedrivercashoutstatus: (id, data) => {
  let url = API_ENDPOINTS.UPDATE_A_DRIVERS_CASHOUTRECORDS + "/" + id;
  return axios.put(url, data, {
    headers: {
      isAuthRequired: true,
      "Content-Type": "application/json","x-tenant-slug":"default"
    },
  });
},

   getdriverscashoutsheets: (params) => {
    return axios.get(API_ENDPOINTS.GET_A_DRIVERS_CASHOUTSHEETS, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
      params,
    });
  },
updatedrivercashoutsheets: (id, data) => {
  let url = API_ENDPOINTS.UPDATE_A_DRIVERS_CASHOUTSHEETS + "/" + id;
  return axios.put(url, data, {
    headers: {
      isAuthRequired: true,
      "Content-Type": "application/json","x-tenant-slug":"default"
    },
  });
},

  addDriver: (data) => {
    return axios.post(API_ENDPOINTS.ADD_DRIVER, data, {
      headers: { isAuthRequired: true, "Content-Type": "multipart/form-data" },"x-tenant-slug":"default"
    });
  },
  createVehicleLeasePurchase: (formData) => {
    // Content-Type volontairement omis : le navigateur pose lui-même le boundary multipart.
    return axios.post(API_ENDPOINTS.VEHICLE_LEASE_PURCHASE, formData, {
      headers: { isAuthRequired: true, "x-tenant-slug": "default" },
    });
  },
  updateDriver: (id, data) => {
    let url = API_ENDPOINTS.UPDATE_DRIVER + "/" + id;
    return axios.put(url, data, {
      headers: { isAuthRequired: true, "Content-Type": "multipart/form-data" },"x-tenant-slug":"default"
    });
  },
      getDriverbankDetailsById: (id) => {
    let url = API_ENDPOINTS.GET_DRIVER_BANK_DETAILS_BY_ID + "/" + id;
    return axios.get(url, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },"x-tenant-slug":"default"
    });
  },
    updateDriverbankdetails: (id, data) => {
    let url = API_ENDPOINTS.UPDATE_DRIVER_BANK_DETAILS_BY_ID + "/" + id;
    return axios.post(url, data, {
     headers: { isAuthRequired: true, "Content-Type": "application/json" },"x-tenant-slug":"default"
    });
  },
  updateDriverRide: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_DRIVER_RIDE, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },"x-tenant-slug":"default"
    });
  },
  createDriverRide: (data) => {
    return axios.post(API_ENDPOINTS.CREATE_DRIVER_RIDE, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },"x-tenant-slug":"default"
    });
  },
  getDriverServiceDetails: (id) => {
    let url = `${API_ENDPOINTS.GET_DRIVER_SERVICE_DETAILS}` + "/" + id;
    return axios.get(url, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },
  getDriverDocumentsByDriverId: (id) => {
    let url = `${API_ENDPOINTS.GET_DRIVER_DOCUMENTS_BY_DRIVER_ID}` + "/" + id;
    return axios.get(url, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },
  updateDriverDocument: (data) => {
    let url = `${API_ENDPOINTS.UPDATE_DRIVER_DOCUMENT_END_POINT}`;
    return axios.put(url, toMultipartFormData(data), {
      headers: {
        isAuthRequired: true,
        "x-tenant-slug":"default"
      },
    });
  },
  updateCorporateDocument: (data) => {
    let url = `${API_ENDPOINTS.UPDATE_CORPORATE_DOCUMENT_END_POINT}`;
    return axios.put(url, toMultipartFormData(data), {
      headers: {
        isAuthRequired: true,
        "x-tenant-slug":"default"
      },
    });
  },
  deleteDriverDocument: (data) => {
    let url = `${API_ENDPOINTS.DELETE_DRIVER_DOCUMENT_END_POINT}`;
    return axios.request({
      method: "delete",
      url: url,
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default" // Use JSON for the body
      },
      data: data, // Pass the `document_id` in the request body
    });
  },
  createDriverDocuments: (data) => {
    let url = `${API_ENDPOINTS.DRIVER_DOCUMENT_END_POINT}`;
    return axios.post(url, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },
  updateDriverDocumentStatus: (driverId, documentId, data) => {
    let url =
      `${API_ENDPOINTS.DRIVER_DOCUMENT_UPDATE}` +
      "/" +
      driverId +
      "/" +
      documentId;
    return axios.put(url, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },
  getDriverCompleteDetailsByDId: (driverId) => {
    let url = `${API_ENDPOINTS.DRIVER_COMPLETE_DETAILS}` + "/" + driverId;
    return axios.get(url, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },
  updateDriverServiceStatus: (driverId, data) => {
    let url = `${API_ENDPOINTS.UPDATE_DRIVER_SERVICE_STATUS}` + "/" + driverId;
    return axios.put(url, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },
};
